/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import DeviceSetup from './device_setup/DeviceSetup';

let FinishSetup = ({ viewer }) => {
  return (
    <div className="max-w-4xl mx-auto w-full">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Finish Setup</h1>
        <p className="text-gray-600">Complete your account setup and configure your devices</p>
      </div>
      <DeviceSetup viewer={viewer} />
    </div>
  );
};

FinishSetup = createFragmentContainer(FinishSetup, {
  viewer: graphql`
    fragment FinishSetup_viewer on User {
      ...DeviceSetup_viewer
      email
      devices(first: 100) @connection(key: "Home_devices") {
        edges {
          node {
            id
          }
        }
      }
    }
  `,
});

export default FinishSetup;
